import { createSlice } from '@reduxjs/toolkit';

interface NavbarState {
  open: boolean;
  mobileOpen: boolean;
}

const initialState: NavbarState = {
  open: true,
  mobileOpen: false,
};

const navbarSlice = createSlice({
  name: 'navbar',
  initialState,
  reducers: {
    navbarToggleFolded: (state) => {
      state.open = !state.open;
    },
    navbarOpenFolded: (state) => {
      state.open = true;
    },
    navbarCloseFolded: (state) => {
      state.open = false;
    },
    navbarToggleMobile: (state) => {
      state.mobileOpen = !state.mobileOpen;
    },
    navbarOpenMobile: (state) => {
      state.mobileOpen = true;
    },
    navbarCloseMobile: (state) => {
      state.mobileOpen = false;
    },
    navbarClose: (state) => {
      state.open = false;
    },
    navbarOpen: (state) => {
      state.open = true;
    },
    navbarToggle: (state) => {
      state.open = !state.open;
    },
  },
});

export const {
  navbarToggleFolded,
  navbarOpenFolded,
  navbarCloseFolded,
  navbarOpen,
  navbarClose,
  navbarToggle,
  navbarOpenMobile,
  navbarCloseMobile,
  navbarToggleMobile,
} = navbarSlice.actions;

export const selectFuseNavbar = ({ fuse }: { fuse: { navbar: NavbarState } }) => fuse.navbar;

export default navbarSlice.reducer;
